<template>
	<div
			class="main-navigation-wrapper"
			:class="{ 'mobile-menu-opened': openedMobileMenu }"
	>
		<button
				type="button"
				class="ml-auto btn btn-menu btn-outline-secondary"
				@click="openedMobileMenu = !openedMobileMenu"
		>
			<font-awesome-icon icon="bars"/>
			Menu
		</button>
		<div class="main-navigation">
			<div class="menu-wrapper">
				<ul class="navbar-nav">
					<li class="nav-item">
						<router-link :to="{ name: 'dashboard' }" class="nav-link"
						>Prehľad
						</router-link
						>
					</li>
					<li class="nav-item">
						<router-link :to="{ name: 'assets' }" class="nav-link"
						>Majetok
						</router-link
						>
					</li>
					<li class="nav-item">
						<router-link :to="{ name: 'transactions' }" class="nav-link"
						>Transakcie
						</router-link
						>
					</li>
					<li v-if="!isMobile" class="nav-item c-pointer">
			<span class="nav-link">
			  Pokyny
			  <font-awesome-icon icon="angle-down" class="text-warning"/>
			</span>
						<ul>
							<li>
								<a @click="showModal('withdrawal')">
									Pokyn na vklad/výber peňažných prostriedkov
								</a>
							</li>
							<li>
								<a @click="showModal('trade')">
									Pokyn na nákup/predaj cenných papierov
								</a>
							</li>
						</ul>
					</li>
					<b-nav-item-dropdown v-if="isMobile" text="Pokyny">
						<b-dropdown-item @click="showModal('withdrawal')">
							Pokyn na vklad/výber peňažných prostriedkov
						</b-dropdown-item>
						<b-dropdown-item @click="showModal('trade')">
							Pokyn na nákup/predaj cenných papierov
						</b-dropdown-item>
					</b-nav-item-dropdown>
					<li class="nav-item">
						<router-link :to="{ name: 'profile' }" class="nav-link"
						>Profil
						</router-link
						>
					</li>
				</ul>
			</div>
			<Request ref="request" :type="requestType" :request-info="requestInfo" />
			<div class="submenu-wrapper menu-wrapper">
				<ul class="navbar-nav">
					<li
							class="nav-item c-pointer"
							v-if="assignedToMe.length > 0 && !loading && !isMobile"
					>
						<div class="nav-link text-capitalize">
							<div class="name-ellipsis d-table-cell pr-2">
								{{ tempUser.fullName }}
							</div>
							<div class="d-table-cell">
								<font-awesome-icon icon="angle-down" class="text-warning"/>
							</div>
						</div>
						<ul class="users-wrapper">
							<li v-for="(assignedUser, i) in assignedToMe" :key="i">
								<a @click="switchUser(assignedUser.id)">
									{{ assignedUser.fullName }}
								</a>
							</li>
						</ul>
					</li>
					<b-nav-item-dropdown
							class="users-wrapper-mobile"
							v-if="assignedToMe.length > 0 && isMobile"
							:text="tempUser.fullName"
					>
						<b-dropdown-item
								v-for="(assignedUser, i) in assignedToMe"
								@click="switchUser(assignedUser.id)"
								:key="i"
						>
							{{ assignedUser.fullName }}
						</b-dropdown-item>
					</b-nav-item-dropdown>
					<li v-if="!isMobile" class="nav-item nav-item-messages">
						<div class="nav-link mx-0">
							<router-link
									:to="{ name: 'messages' }"
									class="btn text-white"
									v-b-tooltip.hover
									title="Centrum správ"
							>
								<font-awesome-icon :icon="['far', 'envelope']"/>
								<span class="badge" v-if="status.total > 0">
				  {{ status.total }}
				</span>
							</router-link>
						</div>
					</li>
					<li v-if="isMobile" class="nav-item nav-item-messages">
						<div class="nav-link mx-0">
							<router-link
									:to="{ name: 'messages' }"
									class="btn text-white"
									v-b-tooltip.hover
									title="Centrum správ"
							>
								<font-awesome-icon :icon="['far', 'envelope']"/>
								<span class="badge" v-if="status.total > 0">
				  {{ status.total }}
				</span>
							</router-link>
						</div>
					</li>

					<li v-if="!isMobile" class="nav-item c-pointer">
			<span class="nav-link">
			  <font-awesome-icon icon="cog"/>
			</span>
						<ul class="settings">
							<li>
								<a @click="openedChangePasswordModal = true">
									<font-awesome-icon icon="lock" class="mr-2"/>
									Zmena hesla
								</a>
							</li>
						</ul>
					</li>

					<b-nav-item-dropdown v-if="isMobile" icon="cog">
						<template slot="button-content"
						>
							<font-awesome-icon icon="cog" class="mr-1"
							/>
						</template>
						<b-dropdown-item @click="openedChangePasswordModal = true">
							<font-awesome-icon icon="lock" class="mr-2"/>
							Zmena hesla
						</b-dropdown-item>
					</b-nav-item-dropdown>

					<b-modal
							title="Zmena hesla"
							v-model="openedChangePasswordModal"
							modal-footer
					>
						<change-password @changed="openedChangePasswordModal = false"/>
						<template v-slot:modal-footer>
							<div></div>
						</template>
					</b-modal>

					<li class="nav-item">
						<button
								type="button"
								class="btn btn-warning float-left ml-3 mt-2 mt-md-3 ml-md-3"
								@click="logout()"
						>
							Odhlásiť
						</button>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import Request from "./Request";
import ChangePassword from "../components/form/ChangePassword";

export default {
	name: "Navigation",
	components: {
		Request,
		ChangePassword
	},
	computed: {
		status() {
			return this.$store.state.messages.status;
		},
		loading() {
			return this.$store.state.account.loadingUser;
		},
		assignedToMe() {
			return this.$store.state.account.assignedToMe;
		},
		tempUser() {
			return this.$store.state.account.tempUser;
		}
	},
	watch: {
		"$route.path"() {
			this.openedMobileMenu = false;
		}
	},
	mounted() {
		this.$store.dispatch("messages/status");
		// this.$store.dispatch("account/assignedToMe");
		// this.$store.dispatch("assets/loadList", null);
		// this.$store.dispatch("portfolio/portfolios");
		this.setMobile();
		this.$nextTick(function () {
			window.addEventListener("resize", this.setMobile);
		});
	},
	destroyed() {
		window.removeEventListener("resize", this.setMobile);
	},
	methods: {
		logout() {
			this.$store.dispatch("account/logout").then(() => {
				this.$router.push({name: "login"});
			});
		},
		showModal(type) {
			this.requestType = type;
			this.$refs.request.show();
		},
		switchUser(clientId) {
			this.$store.dispatch("account/switchUser", {clientId});
		},
		setMobile() {
			const width = document.body.clientWidth || document.width;
			this.isMobile = width < this.mobileTable;
		},
		setRequestInfo(requestInfo) {
			this.requestInfo = requestInfo;
		},
	},
	data() {
		return {
			openedMobileMenu: false,
			isMobile: false,
			mobileTable: 1200,
			requestType: "",
			openedChangePasswordModal: false,
			requestInfo: {
				isSale: true,
				code: ""
			},
		};
	}
};
</script>

<style lang="scss">
.main-navigation-wrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-grow: 1;

	.btn-menu {
		color: #fff;
	}

	.btn-menu {
		display: none;
	}

	.name-ellipsis {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 150px !important;
	}

	@include media-breakpoint-down(lg) {
		&.mobile-menu-opened {
			.main-navigation {
				position: fixed;
				top: 60px;
				right: 0;
				bottom: 0;
				left: 0;
				background: $gray;
				z-index: 100;
				flex-direction: column;
			}
		}

		.btn-menu {
			display: block;
		}

		&:not(.mobile-menu-opened) {
			.main-navigation {
				display: none;
			}
		}
	}

	@include media-breakpoint-down(md) {
		&.mobile-menu-opened {
			.main-navigation {
				top: 70px;
			}
		}
	}

	.main-navigation {
		display: flex;
		flex-direction: row;
		align-items: center;
		width: 100%;

		@include media-breakpoint-down(lg) {
			overflow-y: scroll;
			padding-bottom: 20px;

			.menu-wrapper {
				width: 100%;

				@include media-breakpoint-only(sm) {
					max-width: 540px;
				}
				@include media-breakpoint-only(md) {
					max-width: 720px;
				}
				@include media-breakpoint-only(lg) {
					max-width: 960px;
				}

				.nav-link {
					$height: 60px;

					height: $height !important;
					line-height: $height !important;
					padding: 0 10px !important;

					border-bottom: #f2f2f2;
				}
			}

			.submenu-wrapper {
				width: 100%;

				@include media-breakpoint-only(sm) {
					max-width: 540px;
				}
				@include media-breakpoint-only(md) {
					max-width: 720px;
				}
				@include media-breakpoint-only(lg) {
					max-width: 960px;
				}
			}
		}

		.navbar-nav {
			flex-direction: row;

			@include media-breakpoint-down(lg) {
				flex-direction: column;
			}
		}
	}
}
</style>
